<div
  class="flex flex-col sm:flex-row sm:items-center justify-between gap-3 p-3.5 rounded-xl border transition-colors shadow-2xs"
  [class]="
    isHistory()
      ? 'border-gray-5 bg-gray-2/50 hover:border-gray-6'
      : 'border-gray-6 surface-default hover:border-gray-7'
  "
>
  <div class="flex items-center gap-3 min-w-0">
    <div
      class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg"
      [class]="
        isOwnership() ? 'bg-indigo-a2 text-indigo-11 border border-indigo-a4' : 'bg-gray-3 text-gray-11'
      "
    >
      <mat-icon [svgIcon]="typeIcon" />
    </div>

    <div class="min-w-0">
      <div class="flex items-center gap-2 flex-wrap">
        <span class="text-sm font-medium text-gray-12 truncate">
          {{ fileName }}
        </span>
        @if (isHistory()) {
          <span
            class="inline-flex items-center px-1.5 py-0.5 rounded bg-gray-4 text-gray-11 font-medium text-[9px] uppercase tracking-wider"
          >
            Précédent
          </span>
        }
      </div>

      <div class="text-xs text-gray-9 flex items-center gap-2 flex-wrap mt-0.5">
        @if (!isOwnership()) {
          <span
            class="inline-flex items-center px-2 py-0.5 rounded-md bg-gray-3 text-gray-11 font-medium text-[10px]"
          >
            {{ typeLabel }}
          </span>
          <span>•</span>
        }
        @if (formattedFileSize) {
          <span>{{ formattedFileSize }}</span>
          <span>•</span>
        }
        @if (doc().status) {
          @switch (doc().status) {
            @case (PropertyDocumentStatus.VERIFIED) {
              <span
                class="inline-flex items-center gap-1 text-[10px] font-medium text-jade-11 cursor-help"
                matTooltip="Document vérifié et conforme"
              >
                <mat-icon class="text-xs! w-3! h-3!" svgIcon="circle-check" />
                Validé
              </span>
            }
            @case (PropertyDocumentStatus.PENDING_REVIEW) {
              <span
                class="inline-flex items-center gap-1 text-[10px] font-medium text-indigo-11 cursor-help"
                matTooltip="Document en cours d'analyse par l'équipe ETXE"
              >
                <mat-icon class="text-xs! w-3! h-3!" svgIcon="loader" />
                En attente
              </span>
            }
            @case (PropertyDocumentStatus.REJECTED) {
              <span
                class="inline-flex items-center gap-1 text-[10px] font-medium text-ruby-11 cursor-help"
                [matTooltip]="'Document refusé : ' + (doc().rejectionReason || 'Non conforme ou illisible')"
              >
                <mat-icon class="text-xs! w-3! h-3!" svgIcon="circle-alert" />
                Refusé
              </span>
            }
          }
        }
      </div>
      @if (doc().status === PropertyDocumentStatus.REJECTED && doc().rejectionReason) {
        <div class="mt-1 flex items-center gap-1.5 text-xs text-ruby-11 font-medium">
          <mat-icon class="text-xs! w-3.5! h-3.5! shrink-0" svgIcon="triangle-alert" />
          <span class="truncate">Motif : {{ doc().rejectionReason }}</span>
        </div>
      }
    </div>
  </div>

  <div class="flex items-center gap-2 self-end sm:self-auto shrink-0">
    <!-- View document -->
    @if (fileUrl; as url) {
      <a mat-stroked-button [href]="url" target="_blank" rel="noopener noreferrer" class="text-xs">
        <mat-icon svgIcon="external-link" />
        <span>Consulter</span>
      </a>
    }

    <!-- Admin status modifier -->
    @if (isAdmin()) {
      <etxe-property-document-admin-status-menu
        [doc]="doc()"
        [propertyId]="propertyId()"
        (propertyUpdated)="propertyUpdated.emit($event)"
      />
    }

    <!-- Replace document -->
    @if (canReplace() && editable() && !isVerified()) {
      <button
        mat-stroked-button
        type="button"
        (click)="replace.emit()"
        [disabled]="isDeleting()"
        class="text-xs"
      >
        <mat-icon svgIcon="refresh-cw" />
        <span>Remplacer</span>
      </button>
    }

    <!-- Delete document -->
    @if (editable() && canDelete()) {
      <button
        mat-icon-button
        type="button"
        (click)="delete.emit(doc())"
        [disabled]="isDeleting()"
        class="text-ruby-11 hover:bg-ruby-a3 rounded-full"
        title="Supprimer ce document"
      >
        <mat-icon svgIcon="trash-2" />
      </button>
    }
  </div>
</div>
